import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';
const justifyLeft = createElement(SVG, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, createElement(Path, {
  d: "M9 9v6h11V9H9zM4 20h1.5V4H4v16z"
}));
export default justifyLeft;
//# sourceMappingURL=justify-left.js.map